import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faSearch, faPlusCircle, faArrowAltCircleRight, faArrowAltCircleLeft, faTimes, faKey, faSignOutAlt, faFileDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/global.css'

library.add(faUser, faSearch, faPlusCircle, faArrowAltCircleRight, faArrowAltCircleLeft, faTimes, faKey, faSignOutAlt, faFileDownload)

// Axios Default Config
// axios.defaults.baseURL = "http://localhost:3000/"
axios.defaults.baseURL = "http://103.52.145.250:3000/"
axios.defaults.timeout = 20000
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Accept'] = 'application/json'

// Axios interceptor for 401 responses
axios.interceptors.response.use(function(response) {
    return response
}, function (error) {
    router.push("/login")
    return Promise.reject(error)
})

Vue.config.productionTip = false

// Global variables and functions
Vue.prototype.$axios = axios

Vue.prototype.$core = {
    id: 0,
    general: {},
    input: {},
    dirtyInput: {},
    output: {},
    pump: {},
    equipment: {},
    trajectory: {},
    attachment: {
        ipr: false,
        pump: false
    },
    idConstraint: 0
}

Vue.prototype.$helper = {

    roundify(input) {
        if(Number.isInteger(input)) {
            return input
        }
        else if(isNaN(input)) {
            return input
        }
        else {
            return Number(input).toFixed(3)
        }
    },

    toastError(vue, message) {
        vue.$bvToast.toast(message, {
            title: 'Error',
            variant: "danger",
            solid: true
        })
    },

    toastSuccess(vue, message) {
        vue.$bvToast.toast(message, {
            title: 'Success!',
            variant: "success",
            solid: true
        })
    }

}

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
